import { FilterState } from '../../../../containers/applicant_tracking/Analytics/Filters';
import { StageHeatmap } from '../../../../entities/applicant_tracking/analytics/StageHeatmap';
import { ApiService } from '../../../ApiService';
import { mapToParams } from '../mapToParams';

export class StageHeatmapService {
  public static show(
    filterState?: FilterState,
    signal?: AbortSignal,
    groupBy?: string,
  ): Promise<StageHeatmap> {
    const params = {
      ...mapToParams(filterState),
      ...(groupBy != null && { group_by: groupBy }),
    };

    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/stage_heatmap',
      params,
      { signal },
    );
  }
}
